import React from 'react'
import Gallery from 'react-photo-gallery'
import Lightbox from 'react-images'

export default class MyGallery extends React.Component {
  constructor() {
    super()
    this.state = {
      currentImage: 0,
      photoArray: [],
      photoArrayLarge: [],
      galleryTitle: 'Gallery',
      page: 1
    }
    this.closeLightbox = this.closeLightbox.bind(this)
    this.openLightbox = this.openLightbox.bind(this)
    this.gotoNext = this.gotoNext.bind(this)
    this.gotoPrevious = this.gotoPrevious.bind(this)
  }
  openLightbox(_event, obj) {
    this.setState({
      currentImage: obj.index,
      lightboxIsOpen: true
    })
  }

  closeLightbox() {
    this.setState({
      currentImage: 0,
      lightboxIsOpen: false
    })
  }
  gotoPrevious() {
    this.setState({
      currentImage: this.state.currentImage - 1
    })
  }
  gotoNext() {
    this.setState({
      currentImage: this.state.currentImage + 1
    })
  }
  getPagedPhotoArray = () => {
    return this.state.photoArray.filter((a, i) => {
      return i < this.state.page * 9
    })
  }
  gotoNextPage = () => {
    let currentPage = this.state.page
    currentPage++
    this.setState({
      page: currentPage
    })
  }
  componentDidMount() {
    if (this.props.content) {
      //  For grid
      const photoArray = this.props.content.acf.images
        .map((a, i) => {
          if (!a.image) return null
          return {
            src: a.image.sizes.medium_large,
            width: a.image.sizes['medium_large-width'],
            height: a.image.sizes['medium_large-height'],
            key: i
          }
        })
        .filter(a => a !== null)
      this.setState({
        photoArray,
        galleryTitle: this.props.content.post_title
      })
      //  For popup
      const photoArrayLarge = this.props.content.acf.images
        .map((a, i) => {
          if (!a.image) return null
          return {
            src: a.image.sizes.large,
            width: a.image.sizes['large-width'],
            height: a.image.sizes['large-height'],
            key: i
          }
        })
        .filter(a => a !== null)
      this.setState({
        photoArrayLarge
      })
    } else if (this.props.galleryTitle && this.props.photoArray) {
      this.setState({
        photoArray: this.props.photoArray,
        photoArrayLarge: this.props.photoArray,
        galleryTitle: this.props.galleryTitle
      })
    }
  }
  render() {
    return (
      <div className="my-gallery-container" style={this.props.styles}>
        <h2>{this.state.galleryTitle}</h2>
        <Gallery
          photos={this.getPagedPhotoArray()}
          onClick={this.openLightbox}
        />
        {this.state.page * 9 < this.state.photoArray.length ? (
          <p
            style={{
              textAlign: 'center',
              width: '100%',
              padding: '20px',
              cursor: 'pointer'
            }}
          >
            <a onClick={this.gotoNextPage} className="more-butt">
              <i class="fa fa-long-arrow-down" aria-hidden="true" />
            </a>
          </p>
        ) : (
          ''
        )}
        <Lightbox
          images={this.state.photoArrayLarge}
          onClose={this.closeLightbox}
          onClickPrev={this.gotoPrevious}
          onClickNext={this.gotoNext}
          currentImage={this.state.currentImage}
          isOpen={this.state.lightboxIsOpen}
        />
      </div>
    )
  }
}
